export const UPDATE_THEME = 'UPDATE_THEME'

export type ThemeOptions = 'light' | 'dark'

export type ThemeState = {
  theme: ThemeOptions
  updateTheme: (theme: ThemeOptions) => void
}

export type ThemeAction = {
  type: 'UPDATE_THEME'
  payload: ThemeOptions
}
